/**
 * Full PassiveIearn logo image — uses the official artwork.
 * Sizes: sm 28px, md 40px, lg 64px, xl 120px, 2xl 200px (height-based).
 */
export default function LogoMark({ size = "md", className = "", alt = "PassiveIearn" }) {
  const heights = {
    sm: "h-7",
    md: "h-10",
    lg: "h-16",
    xl: "h-32",
    "2xl": "h-48",
  };
  return (
    <img
      src="/logo.png"
      alt={alt}
      className={`${heights[size] || heights.md} w-auto object-contain select-none ${className}`}
      draggable={false}
    />
  );
}
